import { useQuery } from 'react-query';
import { BeatLoader } from 'react-spinners';
import CollectionsGrid from '../../Components/CollectionsGrid';
import SpotlightCarousel from '../../Components/SpotlightCarousel';
import { fetchCollections } from '../../lib/api';

export const Home = () => {
  const { isLoading: publicCollectionsLoading, data: publicCollections } =
    useQuery({
      queryKey: ['collections'],
      queryFn: fetchCollections,
    });

  return (
    <div className="public-collections-wrapper">
      <h2>Spotlight</h2>
      <SpotlightCarousel collectionId={57} />
      <h2>Collections</h2>
      <CollectionsGrid collections={publicCollections} />
      {publicCollectionsLoading && <BeatLoader color="#000000" />}
    </div>
  );
};
